export const paymentAccounts = {
  // A Stripe e a Wompi são DUAS integrações, não duas opções da mesma:
  // cada uma tem o seu ecrã e o seu cabeçalho. `tagline` é a linha que
  // situa (onde cobra e com que meios).
  header: {
    stripe: {
      title: "Cobranças com o Stripe",
      tagline: "Cartões internacionais · Espanha e a maioria dos países",
      description:
        "Ligue uma ou várias contas do Stripe e escolha com qual cobra cada anúncio.",
    },
    wompi: {
      title: "Cobranças com a Wompi",
      tagline: "Colômbia · PSE, Nequi e cartões colombianos",
      description:
        "Ligue uma ou várias contas da Wompi e escolha com qual cobra cada anúncio.",
    },
    bold: {
      title: "Cobranças com Bold",
      tagline: "Colômbia e Peru · PSE, Nequi, Bancolombia e cartões",
      description:
        "Conecta uma ou várias contas Bold e escolhe com qual cobra cada anúncio.",
    },
    redsys: {
      title: "Cobranças com Redsys",
      tagline: "Espanha · O TPA virtual do seu banco",
      description:
        "Ligue o TPA virtual do seu banco e escolha com que conta cobra cada anúncio. O dinheiro chega diretamente à sua conta bancária.",
      card: "TPA virtual do seu banco (Espanha)",
    },
  },

  // A Wompi onde não se aplica. A passarela é decidida pelo país do
  // ANÚNCIO, não pelo do dono: por isso fala-se de alojamentos e não
  // de si.
  notAvailable: {
    title: "A Wompi é para alojamentos na Colômbia",
    text: "A Wompi cobra em pesos colombianos com PSE, Nequi e cartões da Colômbia. Não tem nenhum alojamento lá, por isso aqui não há nada para ligar.",
    hint: "Se publicar um alojamento na Colômbia, este ecrã abre-se sozinho.",
    button: "Ir para {provider}",
  },

  session: {
    title: "A sua sessão expirou",
    text: "Não se perdeu nada: as suas contas de cobrança continuam ligadas. Volte a entrar para as ver.",
    button: "Voltar a entrar",
  },

  status: {
    ready: "Pronta",
    incomplete: "Incompleta",
    unverified: "Por verificar",
  },

  environment: {
    test: "Testes",
  },

  accounts: {
    card: {
      title: "As suas contas {provider}",
      subtitle: "Ligue contas novas e veja se estão prontas para cobrar.",
    },
    searchPlaceholder: "Procurar conta por nome…",
    newButton: "Ligar conta {provider}",
    noName: "Sem nome",
    fallbackName: "Conta #{id}",
    defaultBadge: "Principal",
    listingsCount: "{count} anúncio | {count} anúncios",
    empty: {
      none: "Ainda não ligou nenhuma conta {provider}.",
      noMatch: "Nenhuma conta corresponde à pesquisa.",
    },
    actions: {
      edit: "Editar",
      setDefault: "Tornar principal",
      isDefault: "Já é a principal",
      resume: "Continuar o registo",
      verify: "Verificar",
      disconnect: "Desligar",
    },
  },

  assign: {
    card: {
      title: "Distribuição por anúncio",
      subtitle: "Escolha que anúncios cobra cada conta {provider}.",
    },
    searchPlaceholder: "Procurar anúncio por nome…",
    filter: {
      all: "Todos",
      unassigned: "Sem atribuir",
      notReady: "Sem poder cobrar",
      other: "Cobra pela {provider}",
    },
    // Sem conta atribuída. Quando se sabe qual é a principal, dá-se-lhe o nome:
    // é o que o anfitrião quer saber, por que conta cobra este anúncio.
    autoOption: "Conta principal",
    autoOptionNamed: "Conta principal · {name}",
    autoOptionOther: "Conta principal de {provider} · {name}",
    otherProvider: "Cobra pela {provider} · {name}",
    otherProviderLink: "Gerir em {provider}",
    notReadyRow: "Não pode cobrar",
    notReadyRowTip: "A conta atribuída a este anúncio ainda não está pronta, por isso o hóspede não conseguirá pagar.",
    notReadyAutoRow: "A sua conta principal não pode cobrar",
    notReadyAutoRowTip: "Este anúncio usa a conta principal, que ainda não está pronta. Termine-a ou atribua-lhe outra conta.",
    notReadyBanner: "{count} anúncio não pode cobrar neste momento: a sua conta ainda não está pronta. Os hóspedes não conseguirão pagá-lo até terminar essa conta. | {count} anúncios não podem cobrar neste momento: a sua conta ainda não está pronta. Os hóspedes não conseguirão pagá-los até terminar essa conta.",
    notReadyBannerLink: "Ver esses anúncios",
    defaultSuffix: " (principal)",
    empty: {
      none: "Ainda não tem anúncios.",
      noMatch: "Nenhum anúncio corresponde ao filtro.",
    },
    count: "A mostrar {shown} de {total} anúncios",
  },

  drawer: {
    newTitle: "Ligar uma conta {provider}",
    editTitle: "Editar a conta {provider}",
    subtitle: "Dê-lhe um nome e escolha que anúncios cobra.",
    closeAria: "Fechar o painel",

    stripe: {
      title: "Registo no Stripe",
      subtitle: "O Stripe vai pedir os seus dados e traz-lhe de volta aqui.",
      explain:
        "Levamo-lo ao Stripe para criar a conta com este nome e verificar os seus dados. Ao voltar poderá escolher que anúncios cobra; se deixar o registo a meio, a conta fica aqui à espera para retomar.",
      button: "Continuar no Stripe",
      connecting: "A abrir o Stripe…",
      resumeTitle: "Registo no Stripe a meio",
      resumeSubtitle: "Falta terminar a verificação no Stripe.",
      resumeExplain: "Esta conta foi criada mas não chegou a terminar o registo no Stripe, por isso ainda não pode cobrar. Retome e siga de onde ficou.",
      resumeButton: "Continuar o registo",
    },

    data: {
      title: "Dados da conta",
      subtitle: "O nome é só para si: ajuda-o a distingui-las.",
      label: "Nome da conta",
      labelPlaceholder: "Por exemplo: Apartamentos da praia",
      labelHint: "O hóspede nunca o vê.",
      publicKey: "Chave pública",
      privateKey: "Chave privada",
      privateKeyKept: "Mantém-se a que já tinha",
      privateKeyHint: "Deixe em branco para continuar com a chave guardada.",
      stripeId: "Identificador do Stripe",
    },

    listings: {
      title: "Anúncios que cobra",
      subtitle: "Os que marcar deixam de cobrar pela conta anterior.",
      label: "Anúncios desta conta",
      selectedCount: "{selected} de {total} marcados",
      searchPlaceholder: "Procurar anúncio…",
      selectAll: "Selecionar todas",
      clear: "Limpar",
      takenBy: "agora em {name}",
      noResults: "Nenhum anúncio corresponde à pesquisa.",
      hint: "Os anúncios que não marcar em nenhuma conta cobram pela principal.",
      otherHidden: "Aqui não aparece {count} anúncio que cobra pela {provider}: gere-se no ecrã dele. | Aqui não aparecem {count} anúncios que cobram pela {provider}: gerem-se no ecrã deles.",
    },

    footer: {
      isDefault: "Já é a principal",
      setDefault: "Tornar principal",
      disconnect: "Desligar",
      cancel: "Cancelar",
      save: "Guardar",
      saving: "A guardar…",
    },
  },

  disconnect: {
    title: "Desligar a conta",
    subtitle: "Vai deixar de cobrar com ela.",
    confirm:
      "Vai desligar «{name}». As reservas já cobradas não são afetadas, mas esta conta deixa de aceitar pagamentos novos.",
    blocked:
      "«{name}» ainda cobra {count} anúncio. Antes de a desligar é preciso passá-lo para outra conta. | «{name}» ainda cobra {count} anúncios. Antes de a desligar é preciso passá-los para outra conta.",
    moveLabel: "Mover esses anúncios para",
    moveHint: "Passamo-los para a conta que escolher e depois desligamos esta.",
    cancel: "Cancelar",
    accept: "Desligar",
    seeListings: "Ver esses anúncios",
    moveAndDisconnect: "Mover e desligar",
  },

  loading: {
    accounts: "A carregar as suas contas de cobrança…",
  },

  msg: {
    loadError: "Não conseguimos carregar as suas contas de cobrança.",
    labelRequired: "Dê um nome à conta.",
    publicKeyRequired: "Falta a chave pública da Wompi.",
    privateKeyRequired: "Falta a chave privada da Wompi.",
    saved: "Conta guardada.",
    saveError: "Não conseguimos guardar a conta.",
    stripeNoUrl: "O Stripe não devolveu a ligação de registo. Tente outra vez.",
    stripeConnectError: "Não conseguimos abrir o registo no Stripe.",
    verified: "A conta está verificada.",
    verifiedWithName: "Conta verificada: {name}.",
    notVerified: "A conta ainda não está verificada. Reveja as chaves.",
    verifyError: "Não conseguimos verificar a conta.",
    defaultUpdated: "Já é a conta principal.",
    defaultError: "Não conseguimos mudar a conta principal.",
    disconnected: "Conta desligada.",
    disconnectError: "Não conseguimos desligar a conta.",
    movedAndDisconnected: "Anúncios movidos e conta desligada.",
    savedNotReady: "Atenção: esta conta ainda não pode cobrar e tem {count} anúncio atribuído. Termine-a ou esse anúncio ficará sem cobrar. | Atenção: esta conta ainda não pode cobrar e tem {count} anúncios atribuídos. Termine-a ou esses anúncios ficarão sem cobrar.",
    assignError: "Não conseguimos mudar a conta deste anúncio.",
  },

  integrations: {
    connectedAccounts: "{count} conta ligada | {count} contas ligadas",
    notApplicable: "Para alojamentos na Colômbia",
    notApplicableSpain: "Para alojamentos em Espanha",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "Ambiente",
    environmentHint: "O seu banco dá-lhe uns dados para testes e outros para cobrar a sério. Escolha a quais pertencem os que vai escrever.",
    env: {
      test: "Testes",
      prod: "Real",
    },
    merchantCode: "Número de comerciante (FUC)",
    merchantCodeHint: "Está no contrato do TPA ou no módulo de administração da Redsys. Só algarismos, normalmente nove.",
    terminal: "Terminal",
    terminalHint: "Quase sempre é 1. Se o banco lhe deu vários, o do TPA virtual.",
    secretKey: "Chave de assinatura (SHA-256)",
    secretKeyHint: "No módulo de administração da Redsys → Dados do comerciante → «Ver chave». Verificamo-la com a Redsys ao guardar, sem cobrar nada.",
    onlyEuro: "Só euros · cobra em {currency}",
    onlyEuroTip: "A Redsys só cobra em euros. Atribua este alojamento a outra conta de cobrança.",
    msg: {
      merchantCode: "O número de comerciante só tem algarismos (normalmente nove).",
      terminal: "O terminal é um número de um a três algarismos (quase sempre 1).",
      secretKey: "Falta a chave de assinatura da Redsys.",
    },
  },
};
